/** @jsx jsx */
import { css, jsx } from '@emotion/react';

import * as React from 'react';

import { FullscreenDialog, Typography } from '@coursera/cds-core';

// FIXME: existing import/no-cycle violations are excused to prevent seeing errors when modifying other parts of the same file; please fix it carefully
// eslint-disable-next-line import/no-cycle
import PlanningTool from 'bundles/degree-home/components/v3-dpm/components/PlanningTool/ToolRenderer';

import _t from 'i18n!nls/degree-home';

const { Header, Content } = FullscreenDialog;

type Props = {
  open: boolean;
  closeModal: () => void;
};

const styles = {
  header: css`
    align-items: center;
  `,
  content: css`
    display: flex;
    flex-direction: column;
    gap: var(--cds-spacing-300);
    margin-bottom: var(--cds-spacing-300);
  `,
};

const PlanningToolDialog = ({ open, closeModal }: Props) => {
  return (
    <FullscreenDialog open={open} onClose={closeModal}>
      {/* eslint-disable-next-line @coursera-web/custom-rules/prefer-cds-typography2 -- FIXME: legacy; migrate to Typography2 */}
      <Header css={styles.header} slot1={<Typography variant="h2semibold"> {_t('Graduation plan')}</Typography>} />
      <Content css={styles.content}>
        <PlanningTool />
      </Content>
    </FullscreenDialog>
  );
};

export default PlanningToolDialog;
